import { render, staticRenderFns } from "./CrmEditCall.vue?vue&type=template&id=2cababfc&scoped=true"
import script from "./CrmEditCall.vue?vue&type=script&lang=ts"
export * from "./CrmEditCall.vue?vue&type=script&lang=ts"
import style0 from "./CrmEditCall.vue?vue&type=style&index=0&id=2cababfc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cababfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cababfc')) {
      api.createRecord('2cababfc', component.options)
    } else {
      api.reload('2cababfc', component.options)
    }
    module.hot.accept("./CrmEditCall.vue?vue&type=template&id=2cababfc&scoped=true", function () {
      api.rerender('2cababfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/edit/CrmEditCall.vue"
export default component.exports